<template>
  <transition name="toast-fade">
    <div 
      v-if="visible" 
      class="toast-notification" 
      :class="typeClass"
      @click="close"
    >
      <div class="toast-content">
        <i v-if="icon" class="toast-icon" :class="icon"></i>
        <span class="toast-message">{{ message }}</span>
      </div>
      <button type="button" class="icon-btn icon-btn-sm toast-close" aria-label="Dismiss" @click.stop="close">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToastNotification',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'success', 'warning', 'error'].includes(value)
    },
    duration: {
      type: Number,
      default: 3000
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    typeClass() {
      return `toast-${this.type}`;
    },
    icon() {
      const icons = {
        info: 'fas fa-info-circle',
        success: 'fas fa-check-circle',
        warning: 'fas fa-exclamation-triangle',
        error: 'fas fa-exclamation-circle'
      };
      return icons[this.type];
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startTimer();
      } else {
        this.clearTimer();
      }
    }
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.clearTimer();
        this.timeout = setTimeout(() => {
          this.close();
        }, this.duration);
      }
    },
    clearTimer() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.toast-notification {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 400px;
  box-sizing: border-box;
  background: var(--surface-2);
  color: var(--text);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-card);
  box-shadow: var(--shadow-pop);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  z-index: 9999;
  cursor: pointer;
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.toast-icon {
  font-size: 18px;
  flex: none;
}

.toast-message {
  font-size: 14px;
  flex: 1;
}

.toast-info .toast-icon    { color: var(--muted); }
.toast-success .toast-icon { color: var(--pass); }
.toast-warning .toast-icon { color: var(--warn); }
.toast-error .toast-icon   { color: var(--fail); }

.toast-fade-enter-active, .toast-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.toast-fade-enter, .toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -12px);
}
</style>
